module.exports = __webpack_public_path__ + "static/media/back.94d18724.jpg";